import { render, staticRenderFns } from "./AssetMessage.vue?vue&type=template&id=6101b544&scoped=true"
import script from "./AssetMessage.vue?vue&type=script&lang=js"
export * from "./AssetMessage.vue?vue&type=script&lang=js"
import style0 from "./AssetMessage.vue?vue&type=style&index=0&id=6101b544&prod&lang=scss&scoped=true"
import style1 from "./AssetMessage.vue?vue&type=style&index=1&id=6101b544&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6101b544",
  null
  
)

export default component.exports